// UserModal.js
import React from 'react';
import './TimeAttendanceModal.css';

const TimeAttendanceModal = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="timeAtten-modal">
      <div className="timeAtten-modal-content">
        <h2 className='timeAtten-title'>Time & Attendance Modal</h2>
        {/* Add your modal content here */}
        <button onClick={onClose}>Close Modal</button>
      </div>
    </div>
  );
};

export default TimeAttendanceModal;
